var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("c-button", {
        ref: "menu",
        staticClass: "button",
        attrs: { "data-cy": "notifications-button", size: "lg", icon: "bell2" },
        on: {
          click: function($event) {
            ;(_vm.showPopover = !_vm.showPopover), _vm.handleAnalytics()
          }
        }
      }),
      _vm._v(" "),
      _vm.showPopover
        ? _c(
            "c-popover",
            {
              attrs: {
                position: _vm.notificationsPosition,
                target: _vm.$refs["menu"]
              },
              on: {
                blur: function($event) {
                  _vm.showPopover = false
                }
              }
            },
            [
              _c("NotificationsList", {
                on: {
                  close: function($event) {
                    _vm.showPopover = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8a91cf58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a91cf58","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Notifications/NotificationsContainer.vue
// module id = 2100
// module chunks = 1610